import { FC, useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import { IRouteDefinition } from '@belong/types';
import { logger } from './logger';
import { logClientRouteChange, logError } from './new-relic';

const logUncaughtClientErrors = (event: ErrorEvent | PromiseRejectionEvent) => {
  const err = (event as ErrorEvent).error ?? (event as PromiseRejectionEvent).reason;
  logError(err);
  logger.error(err);
};

interface IGlobalErrorHandlerProps {
  appRoutes: IRouteDefinition[];
}
export const GlobalErrorHandler: FC<IGlobalErrorHandlerProps> = ({ appRoutes }) => {
  const router = useRouter();
  const routeChangeLogger = (nextPage: string) => logClientRouteChange(nextPage, appRoutes);
  useEffect(() => {
    window.addEventListener('error', logUncaughtClientErrors);
    window.addEventListener('unhandledrejection', logUncaughtClientErrors);
    if (router) {
      router.events.on('routeChangeStart', routeChangeLogger);
    }

    return () => {
      window.removeEventListener('error', logUncaughtClientErrors);
      window.removeEventListener('unhandledrejection', logUncaughtClientErrors);
      if (router) {
        router.events.off('routeChangeStart', routeChangeLogger);
      }
    };
  });

  return null;
};
